import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { SplitText } from 'gsap/SplitText';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
// import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
gsap.registerPlugin(ScrollTrigger);// eslint-disable-line
// gsap.registerPlugin(SplitText);// eslint-disable-line
// gsap.registerPlugin(ScrollSmoother);// eslint-disable-line
// gsap.registerPlugin(MorphSVGPlugin);// eslint-disable-line
// import LocomotiveScroll from 'locomotive-scroll';
// common import css
// import 'locomotive-scroll/dist/locomotive-scroll.css';


export default function sclactSugi() {

  // 開発時にはコメントアウト
  gsap.config({
    nullTargetWarn: false,
  });


  document.addEventListener('DOMContentLoaded', () => {

    ScrollTrigger.create({
      trigger: "#js--scrl--btn",
      // markers: true,
      start: "top center",
      end: "bottom bottom",
      toggleClass: { targets: "#bnr-brand", className: "is-show" },
    });

    var trigger = document.getElementById('js--close');
    if(trigger){
      trigger.addEventListener('click', function(){
        var target = document.getElementById('bnr-brand');
        target.classList.toggle('noDis');
      }, false);
    }

    gsap.utils.toArray(".js--scrl--slidein-01").forEach(function(document) {
      const aniSlideinIllust = document.querySelectorAll('.js--slidein-item-01');

      let tlaniSlideinIllust = gsap.timeline({
        scrollTrigger: {
          trigger: document,
          // scrub: true,
          start: "top 75%",
          end: "+=500",
          // markers: true
        }
      });
      tlaniSlideinIllust
        .from(aniSlideinIllust, {
          autoAlpha: 0,
          y:200,
          duration: 2,
          ease: "power4.out"
        });
    });

    gsap.utils.toArray(".js--scrl--slidein-02").forEach(function(document) {
      const aniSlideinIllust = document.querySelectorAll('.js--slidein-item-02');

      let tlaniSlideinIllust = gsap.timeline({
        scrollTrigger: {
          trigger: document,
          // scrub: true,
          start: "top 75%",
          end: "+=500",
          // markers: true
        }
      });
      tlaniSlideinIllust
        .from(aniSlideinIllust, {
          autoAlpha: 0,
          y:200,
          duration: 2,
          ease: "power4.out"
        });
    });

  });


}